import React from 'react'
import { motion } from 'framer-motion';
const SuperAccordion = ({ show, children, className, ...props }) => {
    // const [height, setHeight] = useState("0px");
    // const contentRef = useRef(null);

    // useLayoutEffect(() => {
    //     if (contentRef.current) {
    //         setHeight(show ? `${contentRef.current.scrollHeight}px` : "0px");
    //     }
    // }, [show]);

    return (
        // <div
        //     style={{ height }}
        //     ref={contentRef}
        //     className={`!visible h-0  transition-[height] overflow-hidden  duration-[350ms] ease-[cubic-bezier(0.25,0.1,0.25,1.0)] motion-reduce:transition-none ${className}    `} >
        //     <div className={className}>
        //         {children}
        //     </div>
        // </div>



        <>
            {/* <motion.div
                initial={{ height: 0 }}
                animate={{ height: show ? "auto" : 0, display: show ? "visible" : "hidden" }}
                transition={{ duration: 0.35, ease: "easeInOut" }}
                style={{ overflow: 'inherit' }}
                className={className}
            >
                {children}
            </motion.div> */}
            <motion.div
                {...props}
                initial={{ height: 0, opacity: 0, overflow: "hidden" }}
                animate={{
                    height: show ? "auto" : 0,
                    opacity: show ? 1 : 0,
                    overflow: show ? "unset" : "hidden",
                }}
                transition={{ duration: 0.35, ease: "easeInOut" }}
                // style={{ overflow: 'unset' }}
                className={className}
            >
                {children}
            </motion.div>
        </>

    );
}

export default SuperAccordion